import type { PayJump } from '../../../util/poker'

/**
 * Bubble awareness banner. Renders for the pre-ITM tension moments:
 *  - exactly on the bubble (toGo=1): "EN spiller fra premie"
 *  - within 2: "X fra premie"
 *  - 3+ : nothing (too early to nag)
 *
 * When `kind=secured`, we don't render here — the SeatCard's pay-jump
 * line takes over once you're in the money.
 *
 * Live tournament rooms put up a literal "ON THE BUBBLE" sign during
 * this stretch. We do the same on the phone.
 */
const BubbleBanner = ({ payJump }: { payJump: PayJump | null }) => {
  if (!payJump || payJump.kind !== 'bubble') return null
  if (payJump.toGo > 2) return null

  const copy =
    payJump.toGo === 1
      ? '🫧 Boblen — én spiller fra premie. Hold ut.'
      : `🫧 Boblen — ${payJump.toGo} spillere fra premie.`

  return (
    <div className="mx-2 my-3 rounded-lg bg-gold/20 text-ink-900 px-4 py-2.5 flex items-center justify-center text-sm font-bold shadow-sm">
      {copy}
    </div>
  )
}

export default BubbleBanner
